export const mobileBreakpoint = 480;

export const isMobileScreen = (breakpoint = mobileBreakpoint) => {
	// ! Disabled because it generates a lot of false positives
	const isPortrait = true; // getOrientation() === 'portrait';
	// This calculation is wrong on window.innerWidth because if there are elements that stretch beyond the window width, the value will reflect their width.
	// A more realistic value would be the window.outerWidth, but that includes the sidebar (browser artifacts) and we don't want that
	// return mpro.viewport().width < (landscape ? 992 : 541);
	// console.log('isMobileScreen', breakpoint, isPortrait);
	// console.log(`only screen and (max-${isPortrait ? 'width' : 'height'}: ${breakpoint}px)`, window.matchMedia(`only screen and (max-${isPortrait ? 'width' : 'height'}: ${breakpoint}px)`).matches);
	return window.matchMedia(`only screen and (max-${isPortrait ? 'width' : 'height'}: ${breakpoint}px)`).matches;

	// This is deprecated
	// return window.matchMedia(`(max-device-${isPortrait ? 'width' : 'height'}: ${breakpoint}px)`).matches;
};

export const getOrientation = () => {

	const { screen } = window;
	let orientation;

	// eslint-disable-next-line unicorn/prefer-ternary
	if (('orientation' in screen) && ('type' in screen.orientation)) {
		orientation = screen.orientation.type.replace(/-\w+$/, '');
	}
	// This is not
	// else if (window.matchMedia('(orientation: portrait)').matches) {
	// 	orientation = 'portrait';
	// }
	else {
		orientation = (screen.availHeight > screen.availWidth) ? 'portrait' : 'landscape';
	}

	return orientation;
};

export const isMobile = () => {
	const testRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/;

	// Combined feature detection with userAgent parsing
	return (
		(testRegex.test(navigator.userAgent) || testRegex.test(navigator.platform)) &&
		/Mobi/.test(navigator.userAgent) &&
		isMobileScreen() &&
		('ontouchstart' in document.documentElement)
	) ? true : false;
};

export const isTouchDevice = () => {

	// @ts-ignore
	if (('ontouchstart' in window) || (window.DocumentTouch && document instanceof window.DocumentTouch)) {
		return true;
	}

	const prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');

	// include the 'heartz' as a way to have a non matching MQ to help terminate the join
	// https://git.io/vznFH
	const query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
	return window.matchMedia(query).matches;
};

export const getBasicDeviceData = () => {
	return {
		java_enabled: navigator.javaEnabled && navigator.javaEnabled() || false,
		// @ts-ignore
		agent_lang: navigator.language || navigator.userLanguage,
		color_depth: screen.colorDepth,
		screen_width: screen.width,
		screen_height: screen.height,
	};
};